<div class="results-group-container flexit-compact-mat-table">
  <mat-table [dataSource]="dataSource">
    <ng-container matColumnDef="text">
      <mat-header-cell *matHeaderCellDef>{{ group.TextId | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let property" [matTooltip]="property.TooltipTextId | translate">
        <div class="cell-div">
          {{ property.TextId | translate }}
          @if (property.TitleSuffix) {
            <span>{{ property.TitleSuffix }}</span>
          }
        </div>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="{{ valueDefinition }}">
      <mat-header-cell *matHeaderCellDef>
        {{ (isMinMax ? textIdOverrides?.['UI.Normal'] || 'UI.Normal' : '') | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let property" [matTooltip]="property.TooltipTextId | translate">
        <div class="cell-div">
          @if (property.ValueType.IsNumeric) {
            <ng-container>{{ property | localizeNumberProperty }}</ng-container>
          } @else {
            <ng-container>{{ property.Value | translate }}</ng-container>
          }
          <ng-container>
            {{ property.MeasurementUnitTextId | translate }}
          </ng-container>
        </div>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="minValue">
      <mat-header-cell *matHeaderCellDef>
        {{ (hasMinValue ? textIdOverrides?.['UI.Min'] || 'UI.Min' : '') | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let property" [matTooltip]="property.TooltipTextId | translate">
        @if (property.MinValue) {
          <div class="cell-div">
            {{ property | localizeNumberProperty: 'MinValue' }}
            {{ property.MeasurementUnitTextId | translate }}
          </div>
        }
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="maxValue">
      <mat-header-cell *matHeaderCellDef>
        {{ (hasMaxValue ? textIdOverrides?.['UI.Max'] || 'UI.Max' : '') | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let property" [matTooltip]="property.TooltipTextId | translate">
        @if (property.MaxValue) {
          <div class="cell-div">
            {{ property | localizeNumberProperty: 'MaxValue' }}
            {{ property.MeasurementUnitTextId | translate }}
          </div>
        }
      </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="visibleColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: visibleColumns"></mat-row>
  </mat-table>
</div>
